/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuoteClientTermsResource
 */
export interface QuoteClientTermsResource {
    /**
     * 
     * @type {string}
     * @memberof QuoteClientTermsResource
     */
    fileUrl?: string;
    /**
     * 
     * @type {Date}
     * @memberof QuoteClientTermsResource
     */
    acceptedDate?: Date;
}

/**
 * Check if a given object implements the QuoteClientTermsResource interface.
 */
export function instanceOfQuoteClientTermsResource(value: object): value is QuoteClientTermsResource {
    return true;
}

export function QuoteClientTermsResourceFromJSON(json: any): QuoteClientTermsResource {
    return QuoteClientTermsResourceFromJSONTyped(json, false);
}

export function QuoteClientTermsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteClientTermsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'acceptedDate': json['acceptedDate'] == null ? undefined : (new Date(json['acceptedDate'])),
    };
}

export function QuoteClientTermsResourceToJSON(value?: QuoteClientTermsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fileUrl': value['fileUrl'],
        'acceptedDate': value['acceptedDate'] == null ? undefined : ((value['acceptedDate']).toISOString().substring(0,10)),
    };
}

